<template>
  <mdb-container fluid class="tableResident" v-bind:style="{ fontFamily: 'OpenSans-Regular', fontSize: '12px' }">
    <!--Section: Intro-->
    <mdb-row>
      <mdb-col>
        <h2 class="mt-lg-4 mb-1 pb-1" style="font-family: OpenSans-bold">
          <strong>Residentes</strong>
        </h2>
      </mdb-col>
      <mdb-col>
        <div class="mt-lg-4 mb-1 pb-1">
          <mdb-form-inline>
            <input v-on:keydown.enter.prevent="getResidentes" class="mr-sm-2 filter-input" type="text" v-model="search"
              style="width: 100% !important; border: 0px !important" placeholder="Buscar residente" />
          </mdb-form-inline>
        </div>
      </mdb-col>
    </mdb-row>
    <!--Section: Main panel-->
    <div class="my-5">
      <!--Card-->
      <mdb-card cascade>
        <!--Section: Table-->
        <!--Top Table UI-->
        <div class="card card-cascade narrower z-depth-0">
          <!--Card image-->
          <div class="
              view view-cascade
              narrower
              py-2
              mx-4
              mb-3
              d-flex
              justify-content-between
              align-items-center
            " style="
              margin-top: -2.25rem;
              background-color: #67a3cf;
              position: static;
            ">
            <div class="text-left">
              <mdb-tooltip material trigger="hover" :options="{ placement: 'top' }">
                <span slot="tip">Alta residente</span>
                <a slot="reference" href="/newResidents">
                  <img alt="alta residente" class="mt-0" :src="imgServer + 'apps/myfrac/admin/assets/Crear_BTN@3x.png'
                    " style="
                      margin-left: 1rem;
                      width: 31.2px;
                      height: 31.2px;
                      object-fit: contain;
                    " />
                </a>
              </mdb-tooltip>
            </div>

            <span class="white-text" style="
                font-family: OpenSans-Bold;
                font-size: 16px;
                display: table;
                margin: 0 auto;
              ">Residentes registrados</span>

            <div class="text-right" style="margin-right: 1rem; display: flex; float: right">
              <input type="checkbox" class="form-control form-check-input" id="defaultUnchecked" v-model="useApp" />
              <label class="form-check-label" for="defaultUnchecked" style="
                  font-family: OpenSans-Bold;
                  font-size: 12px;
                  color: #ffffff;
                ">Residentes activados</label>
            </div>
          </div>
          <div v-if="displayedPost.length == 0">
                <h6 class="text-left" style="margin-left: 2rem; display: flex; float: left">No se encontro algún registro con los datos ingresados.</h6>
          </div>
          <div v-else>
            <mdb-container>
            <div class="offset">
              <mdb-tbl class="table-st">
                <mdb-tbl-head class="text-left" responsive>
                  <tr>
                    <th scope="col">Correo</th>
                    <th scope="col">Nombre</th>
                    <th scope="col">Dirección</th>
                    <th v-if="isMe.frac == 'Club Tres Marias'" scope="col">No. de acción</th>
                    <th scope="col">Teléfono</th>
                    <th scope="col">Código</th>
                    <th v-if="hasFacialRecognition" scope="col">Facial</th>
                    <th scope="col">Acciones</th>
                  </tr>
                </mdb-tbl-head>
                <mdb-tbl-body class="text-left" responsive>
                  <tr v-for="(item, index) in displayedPost" v-bind:key="index">
                    <td>{{ item.email }}</td>
                    <td>{{ item.name }}</td>
                    <td>
                      {{ item.testStreet.name + " #" + item.number }}
                      <p>{{ "Zona: " + item.testStreet.testZone.name }}</p>
                    </td>
                    <td v-if="isMe.frac == 'Club Tres Marias'">{{ item.action }}</td>
                    <td>
                      <ul v-for="(phone, idx) in item.phones" v-bind:key="idx">
                        <li>{{ phone.phone }}</li>
                      </ul>
                    </td>
                    <td v-if="item.useapp">
                      <span
                        v-if="((item.testResidentRegistration && hasElapsedFifteenMinutes(item.testResidentRegistration.jwtToken)))">
                        Reenviar: {{ item.testResidentRegistration.code }}
                        <mdb-tooltip material trigger="hover" :options="{ placement: 'top' }">
                          <span slot="tip">Reenviar</span>
                          <mdb-btn slot="reference" outline="white" rounded size="sm" class="px-2 button_background"
                            @click="resendEmailToken(item.uuid)">
                            <mdb-icon icon="share" class="mt-0" />
                          </mdb-btn>
                        </mdb-tooltip>
                      </span>
                      <span v-else-if="item.testResidentRegistration">{{ item.testResidentRegistration.code }}</span>
                      <span v-else>¡Código activado!</span>
                    </td>
                    <td v-else>Residente no activado</td>
                    <td v-if="hasFacialRecognition" class="text-center">
                      <span v-if="item.faceImageRecognition && item.faceImageRecognition.active">
                        <mdb-tooltip material trigger="hover" :options="{ placement: 'top' }">
                          <span slot="tip">Reconocimiento facial activo</span>
                          <mdb-icon slot="reference" icon="user-check" class="facial-active-icon" />
                        </mdb-tooltip>
                      </span>
                      <span v-else>
                        <mdb-tooltip material trigger="hover" :options="{ placement: 'top' }">
                          <span slot="tip">Sin reconocimiento facial</span>
                          <mdb-icon slot="reference" icon="user-times" class="facial-inactive-icon" />
                        </mdb-tooltip>
                      </span>
                    </td>
                    <td>
                      <div>
                        <mdb-tooltip material trigger="hover" :options="{ placement: 'top' }">
                          <span slot="tip">Editar</span>
                          <mdb-btn slot="reference" outline="white" rounded size="sm" class="px-2 button_background"
                            @click="getSingleResident(item.uuid)">
                            <mdb-icon icon="edit" class="mt-0" />
                          </mdb-btn>
                        </mdb-tooltip>
                        <mdb-tooltip v-if="isMe.idUsersTypes != 2" material trigger="hover"
                          :options="{ placement: 'top' }">
                          <span slot="tip">Eliminar</span>
                          <mdb-btn slot="reference" outline="white" rounded size="sm"
                            class="px-2 ml-2 button_background" style="width: 2rem"
                            @click="deleteResident(item.uuid, item.name)">
                            <mdb-icon icon="trash" />
                          </mdb-btn>
                        </mdb-tooltip>
                        <mdb-tooltip v-if="item.status == 'ACTIVE'" material trigger="hover"
                          :options="{ placement: 'top' }">
                          <span slot="tip">Desactivar</span>
                          <mdb-btn slot="reference" outline="white" rounded size="sm" class="px-2 ml-2"
                            style="width: 2rem; background-color: #49a704 !important;"
                            @click="disabledResident(item.uuid)">A</mdb-btn>
                        </mdb-tooltip>
                        <mdb-tooltip v-else material trigger="hover" :options="{ placement: 'top' }">
                          <span slot="tip">Activar</span>
                          <mdb-btn slot="reference" outline="white" rounded size="sm" class="px-2 ml-2"
                            style="background-color: #ff7761 !important;"
                            @click="enabledResident(item.uuid)">N/A</mdb-btn>
                        </mdb-tooltip>
                      </div>
                    </td>
                  </tr>
                </mdb-tbl-body>
              </mdb-tbl>

              <!-- Componente de Paginación -->
              <Pagination :currentPage="page" :totalPages="numberOfPages" @page-change="goToPage" />
            </div>
          </mdb-container>
          </div>
        </div>

        <!--Section: Table-->
      </mdb-card>
      <!--/.Card-->
    </div>
    <!--Section: Main panel-->

    <mdb-modal :show="showModal" @close="
      showModal = false;
    TitleModal = 'Agregar';
    ">
      <mdb-modal-header class="text-center modal-header-style">
        <mdb-modal-title tag="span" class style="color: #ffffff">{{ TitleModal }} residente</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body class="mx-3">
        <mdb-col>
          <form id="gateForm" class="needs-validation" novalidate @submit="submitForm">
            <mdb-row>
              <div class="form-group">
                <label for="nameGate" style="font-family: OpenSans-Semibold; font-size: 12px">Nombre</label>
                <input type="text" class="form-control text-input" id="nameGate" required maxlength="64" minlength="3"
                  v-model="residenteFirstName" style="
                    height: 37px;
                    margin-top: 10px;
                    font-size: 12px;
                    width: 150%;
                  " />
                <div class="valid-feedback">Correcto</div>
                <div class="invalid-feedback">Asigna un nombre</div>
              </div>
            </mdb-row>
            <mdb-row>
              <div class="text-right mb-1" style="
                  display: flex;
                  position: relative;
                  float: right;
                  margin-left: auto;
                ">
                <mdb-btn color="color-prev" type="button" class="btn-prev Rectngulo-14" @click="
                  showModal = false;
                TitleModal = 'Agregar';
                ">Cancelar</mdb-btn>
                <mdb-btn v-if="TitleModal == 'Agregar'" type="submit"
                  class="btn btn-next btn-color-next Rectngulo-14">Registrar</mdb-btn>
                <mdb-btn v-else type="submit" class="btn btn-next btn-color-next Rectngulo-14">Actualizar</mdb-btn>
              </div>
            </mdb-row>
          </form>
        </mdb-col>
      </mdb-modal-body>
    </mdb-modal>
    <Loader v-show="isLoading" />
  </mdb-container>
</template>

<script>
/* eslint-disable */
import Swal from "sweetalert2";
import Axios from "axios";
import Servers from "../../../server.js";
import Loader from "../../core/Loader";
import { mapGetters, mapActions } from "vuex";
import Pagination from '@/components/Pagination.vue'
import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbCard,
  mdbCardImage,
  mdbCardHeader,
  mdbCardBody,
  mdbCardTitle,
  mdbCardText,
  mdbCardFooter,
  mdbCardUp,
  mdbCardAvatar,
  mdbCardGroup,
  mdbSelect,
  mdbBtn,
  mdbDatePicker,
  mdbTooltip,
  mdbSimpleChart,
  mdbIcon,
  mdbFormInline,
  mdbBadge,
  mdbView,
  mdbLineChart,
  mdbListGroup,
  mdbListGroupItem,
  mdbInput,
  mdbDatatable,
  mdbAvatar,
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbModalFooter,
  mdbTbl,
  mdbTblHead,
  mdbTblBody,
} from "mdbvue";

export default {
  name: "Residentes",
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardImage,
    mdbCardHeader,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbCardFooter,
    mdbCardUp,
    mdbCardAvatar,
    mdbCardGroup,
    mdbSelect,
    mdbBtn,
    mdbDatePicker,
    mdbTooltip,
    mdbSimpleChart,
    mdbIcon,
    mdbFormInline,
    mdbBadge,
    mdbView,
    mdbLineChart,
    mdbListGroup,
    mdbListGroupItem,
    mdbInput,
    mdbDatatable,
    mdbAvatar,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbTbl,
    mdbTblHead,
    mdbTblBody,
    Loader,
    Pagination,
  },
  data() {
    return {
      urlServer: Servers.serverApi,
      imgServer: Servers.serverImg,
      residentList: [],
      page: 1,
      perPage: 15,
      pages: [],
      totalElements: 0,
      pageNumber: 1,
      numberOfPages: 0,
      requestShow: false,
      showModal: false,
      search: null,
      residenteFirstName: "",
      whoami: [],
      TitleModal: "Agregar",
      gate: [],
      useApp: false,
      isLoading: false,
      currentTime: new Date().getTime(),
    };
  },
  methods: {
    ...mapActions(["getAllResidents", "enableResident", "disableResident", "resendRegistrationEmail"]),
    async enabledResident(uuid) {
      try {
        await Swal.fire({
          title: "¿Estás seguro de activar este residente? ",
          text: "Solo se activará al residente en el registro, más no se activará el uso de la app de Residentes, para activar el uso de la app será necesario editar el registro.",
          type: "question",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",
          reverseButtons: true,
        }).then((result) => {
          if (result.value) {
            this.enableResident(uuid);
            this.showMessageSucces();
          }
        });
      } catch (error) {
        this.showMessageError(
          "No es posible activar",
          error.response.data.error_description
        );
      }
    },
    async disabledResident(uuid) {
      try {
        await Swal.fire({
          title: "¿Estás seguro de desactivar este residente? ",
          text: "Al desactivar al usuario este perderá el acceso a la app de Residentes si es que está activa, de lo contrtario solo se desactivará del registro. Podras activarlo cuando desees.",
          type: "question",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",
          reverseButtons: true,
        }).then((result) => {
          if (result.value) {
            this.disableResident(uuid);
            this.showMessageSucces();
          }
        });
      } catch (error) {
        this.showMessageError(
          "No es posible desactivar",
          error.response.data.error_description
        );
      }
    },
    async resendEmailToken(uuid) {
      try {
        this.isLoading = true;
        const response = await this.resendRegistrationEmail(uuid);
        // console.log(response.data)
        this.isLoading = false;
        this.showMessageSucces();
      } catch (error) {
        this.isLoading = false;
        this.showMessageError(
          "No es posible reenviar el código",
          error.response.data.error_description
        );
      }
    },
    closeModal() {
      this.TitleModal = "Agregar";
      this.residenteFirstName = "";
    },
    // nextPage(number) {
    //   this.page = number
    //   console.log("PAGE " + this.page)
    // },
    submitForm(event) {
      event.preventDefault();
      event.target.classList.add("was-validated");
    },
    async getResidentes() {
      try {
        this.isLoading = true;
        let response = await this.getAllResidents({ page: this.page, size: this.perPage, search: this.search, useApp: this.useApp });
        //console.log(localStorage.getItem("access_token"))
        this.isLoading = false;
        this.residentList = response.data.data || [];
        this.numberOfPages = response.data.totalPages;
        this.totalElements = response.data.totalElements
        this.pageNumber = response.data.pageNumber
        this.setPages()
      } catch (error) {
        this.isLoading = false;
        this.residentList = [];
        this.numberOfPages = 0;
        this.totalElements = 0;
        this.pageNumber = 1;
        console.error(error)
        // this.showMessageError(
        //   "Error al obtener la lista de residentes",
        //   error.response.data.error_description
        // );
      }
    },
    getSingleResident(uuid) {
      this.TitleModal = "Editar";
      let found = this.residentList.find((element) => element.uuid == uuid);
      console.log('FOUND', found)
      this.residenteFirstName = found.name;
      this.gate = found;
      this.$store.commit("setResident", found);
      this.$store.commit("setEditResident", true);
      this.$router.push("/newResidents");
    },
    deleteResident(uuid, name) {
      let aux = this;
      Swal.fire({
        title: "¿Seguro que deseas eliminar " + name + "?",
        text: "No podrás revetir esta acción",
        type: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        cancelButtonText: "Cancelar",
        reverseButtons: true,
      }).then((result) => {
        if (result.value) {
          Axios.delete(Servers.serverApi + "api/residents/" + uuid, {
            responseType: "application/json",
            headers: {
              Authorization: "Bearer " + localStorage.getItem("access_token"),
            },
          })
            .then(function (response) {
              aux.showMessageSucces();
            })
            .catch(function (error) {
              aux.showMessageError("No es posible eliminar", "");
              console.log(error.response.data);
            });
        }
      });
    },
    setPages() {
      this.pages = [];
      for (let index = 1; index <= this.numberOfPages; index++) {
        this.pages.push(index);
      }
    },
    // paginate(wList) {
    //   let page = this.page;
    //   let perPage = this.perPage;
    //   let from = page * perPage - perPage;
    //   let to = page * perPage;
    //   this.setPages();
    //   return wList.slice(from, to);
    // },
    showMessageError: function (text, error) {
      let aux = this;
      let errorText;
      Swal.fire({
        title: "<span style='font-size: 20px'>" + text + "</span>",
        html: "<span style='font-size: 12px'>" + error + "</span>",
        imageUrl: "../static/Cancel_icon.png",
        imageWidth: "22%",
        imageHeight: "auto",
        width: "30%",
        //confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        customClass: {
          confirmButton: "btn-modal-accept",
        },
        onClose: () => { },
      });
    },
    showMessageSucces: function () {
      Swal.fire({
        title: "<span style='font-size: 20px;'>¡Correcto!</span>",
        html: "<span style='font-size: 12px;'></span>",
        type: "success",
        width: "30%",
        confirmButtonText: "Aceptar",
        customClass: {
          confirmButton: "btn-modal-accept",
        },
        onClose: () => {
          window.location.reload();
        },
      });
    },
    hasElapsedFifteenMinutes(jwtToken) {
      try {
        if (jwtToken == null) { return true }

        const jwt = require('jsonwebtoken')
        const decodedToken = jwt.decode(jwtToken);
        const expirationTime = decodedToken.exp * 1000;
        return this.currentTime - expirationTime >= 0
      } catch (error) {

      }
    },
    goToPage(pageNumber) {
      this.page = pageNumber;
      localStorage.setItem('currentPage', pageNumber);
      this.getResidentes(); // Llamada para actualizar los datos según la página seleccionada
    },
  },
  mounted() { },
  async created() {
    // Recuperar los valores guardados de 'currentSearch' y 'currentPage' desde localStorage
    this.search = localStorage.getItem('currentSearch') || null;
    this.page = parseInt(localStorage.getItem('currentPage')) || 1;

    // Obtener las capacidades del fraccionamiento
    await this.$store.dispatch("fetchFracCapabilities");

    // Obtener los residentes con los valores iniciales
    this.getResidentes();
  },
  beforeRouteLeave(to, from, next) {
    if (to.path !== '/newResidents') {
      localStorage.removeItem('currentSearch');
      localStorage.removeItem('currentPage'); // Limpiar la página actual cuando se cambie de ruta
    }
    next();
  },
  watch: {
    search() {
      this.page = 1;
      localStorage.setItem('currentSearch', this.search);
      localStorage.setItem('currentPage', this.page);
      this.getResidentes();
      this.currentTime = new Date().getTime();
    },
    page() {
      this.getResidentes();
    },
    useApp() {
      this.page = 1;
      this.getResidentes();
    }
  },
  computed: {
    ...mapGetters({
      isMe: "getWhoAmi",
      hasFacialRecognition: "hasFacialRecognition",
    }),
    displayedPost() {
      return this.residentList;
    },
  },
};
</script>

<style scoped>
.tableResident {
  overflow-x: hidden;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #fff;
  opacity: 1;
  /* Firefox */
}

:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #fff;
}

::-ms-input-placeholder {
  /* Microsoft Edge */
  color: #fff;
}

.table-st {
  border-collapse: collapse !important;
  margin-bottom: 0 !important;
  padding-bottom: 0 !important;
  margin-top: 0 !important;
}

.tooltip-p {
  position: relative;
  display: inline-block;
}

/* Tooltip text */
.tooltip-p .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: #555;
  color: #fff;
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;

  /* Position the tooltip text */
  position: absolute;
  z-index: 1;
  bottom: 125%;
  left: 50%;
  margin-left: -60px;

  /* Fade in tooltip */
  opacity: 0;
  transition: opacity 0.3s;
}

/* Tooltip arrow */
.tooltip-p .tooltiptext::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #555 transparent transparent transparent;
}

/* Show the tooltip text when you mouse over the tooltip container */
.tooltip-p:hover .tooltiptext {
  visibility: visible;
  opacity: 1;
}

.HeadBG {
  background-color: #f5f6fa;
  font-family: "OpenSans-Semibold" !important;
  color: #747474;
  font-size: 12px;
  text-align: center !important;
}

.table>tbody {
  text-align: center;
}

.Trazado-295 {
  width: auto;
  height: 35px;
  border: solid 1px #e8e9ec;
  background-color: #ffffff;
}

select {
  width: auto;
  height: 35px;
  border: solid 1px #e8e9ec !important;
  background-color: #67a3cf !important;
}

.filter-input {
  position: initial;
  margin-left: 0.5em;
  margin-right: 1rem;
  margin-top: 2rem;
  border-radius: 25px;
  height: 35px;
  padding-left: 35px;
  padding-top: 8px;
  padding-bottom: 8px;
  padding-right: 10px;
  font-family: "OpenSans-Regular";
  font-size: 12px;
  color: #fff;
  background: url("../../../static/zoom_in.png") no-repeat scroll 12px 7px #67a3cf;
  background-size: 20px 20px;
}

.filter-input:focus {
  font-family: "OpenSans-Regular";
  font-size: 12px;
  color: #fff;
  background: url("../../../static/zoom_in.png") no-repeat scroll 12px 7px #67a3cf;
  background-size: 20px 20px;
}

.modal-header-style {
  height: 51.5px;
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.08);
  background-color: #67a3cf;
}

.table>thead>tr>th {
  text-align: left !important;
}

.table>thead>tr>th:nth-child(4),
.table>thead>tr>th:nth-child(6) {
  text-align: center !important;
}

.table>tbody>tr>td:last-child {
  width: 100%/6;
  text-align: center;
}

.pagination--active {
  color: white !important;
  background-color: #025897 !important;
  border-color: #025897 !important;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.4) !important;
}

.facial-active-icon {
  color: #49a704;
  font-size: 18px;
}

.facial-inactive-icon {
  color: #ff7761;
  font-size: 18px;
}

@media screen and (max-width: 770px) {
  .tableResident {
    overflow-x: visible;
  }
}
</style>